export default __webpack_public_path__ + "static/media/low.7b0f5ef9.png";